import { Grid, Typography } from '@mui/material';
import React from 'react'
import style from "../../../assets/styles/componentStyles/orderDetailStyles/orderDetailStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import { thousandSeparator } from '../../../utils/constants';
import { useOrderDetailStore } from '../../../store/orderDetailStore';
import { useShallow } from 'zustand/react/shallow';

const OrderCard = () => {

    const { totalOrders, totalPaidOrders, totalNotPaidOrders } = useOrderDetailStore(useShallow((state) => ({
        totalOrders: state.totalOrders,
        totalPaidOrders: state.totalPaidOrders,
        totalNotPaidOrders: state.totalNotPaidOrders,
    })))

    const cards = [
        {
            title: "Total Orders",
            value: totalOrders
        },
        {
            title: "Paid Orders",
            value: totalPaidOrders
        },
        {
            title: "Unpaid Orders",
            value: totalNotPaidOrders
        }
    ];

    return (
        <>
            <Grid container gap={3} className={`${globalStyles.fullwidth} ${style.cardsRow}`}>
                {cards?.map((card, index) => {
                    return (
                        <Grid item key={index}>
                            <Grid container className={style.cardContainer}>
                                <Grid item className={style.cardTitle}>
                                    <Typography>{card.title}</Typography>
                                </Grid>
                                <Grid item className={style.cardValue}>
                                    <Typography>{thousandSeparator(card.value)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </>
    )
}

export default OrderCard
